import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import { useNavigate } from "react-router-dom";
import { fetchPayment, setAmount } from '../slices/payment.slice';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { removeComma, separateNumber } from '../helpers/mmg';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ErrorIcon from '@mui/icons-material/Error';
import queryString from 'query-string'; 
import { resetRXOrderResultBox } from '../slices/rxorder.slice';
import { resetSTOrderResultBox } from '../slices/storder.slice';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const zeroPad = (num, places) => String(num).padStart(places, '0');

const boxSX = {
   backgroundColor : '#FFEB3B', color: '#37474F' ,
  "&:hover": {
    color: '#FFEB3B',
    backgroundColor: '#37474F'
  },
};


export const PaymentResult = () => {


  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'))
  //const defaultValues = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  let navigate = useNavigate();

  //نحوه گرفتن کویری اسرتینک برای بازگشت از پرداخت انلاین
  console.log("PARAMS");
  console.log(window.location.pathname.replace('/PaymentResult','').split('/'));
  var resultType =  window.location.pathname.replace('/PaymentResult','').split('/')[1];
  var resultCode = window.location.pathname.replace('/PaymentResult','').split('/')[2];
  var msg =  window.location.pathname.replace('/PaymentResult','').split('/')[3];



  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    //color: theme.palette.text.secondary,
  }));
  //این اوکیه
  //const [searchParams] = useSearchParams();
  //let entityId = searchParams.get("entityId");



   useEffect(() => {
    

   }, []);



   const mdTheme = createTheme({

    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
});


const handleClickST = (e) =>{

  dispatch(resetSTOrderResultBox());
  navigate('/ST');

}

const handleClickRX = (e) =>{

  dispatch(resetRXOrderResultBox());
  navigate('/RX');

}

const handleClickOrders = (e) =>{

  dispatch(resetSTOrderResultBox());
  navigate('/Orders');

}

return (
    <>

<ThemeProvider theme={mdTheme}>
<br/><br/><br/><br/><br/><br/>
  <Box sx={{ flexGrow: 1 }}>
  <Grid container
    justify="center"
    style={{ minHeight: '100vh' }}>
              <Grid item xs={12}>           
        <Card sx={{ minWidth: 275 }}>
      <CardContent
       style={{textAlign: 'center'}}
      >
        <Typography variant="h6" component="div">
        <AttachMoneyIcon sx={{ color: "#3F51B5" }} />    نتیجه عملیات پرداخت

        <AttachMoneyIcon sx={{ color: "#3F51B5" }} /> 
        </Typography>
        <hr/>
        <br/>
      {resultType.toString() === "1" ? 
      <span>
        <DownloadDoneIcon sx={{ color: "#66BB6A" }}/>
        <br/>
        <Typography component="div" sx={{ color: "#66BB6A" }}>
        <ErrorIcon sx={{ color: "#66BB6A" }} />پرداخت با موفقیت انجام شد&nbsp;  پیگیری  :&nbsp; {resultCode}
        </Typography>
        <br/>
        <hr/>
        <br/>
        <Grid container justify='space-between' spacing={2}>
        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
      <Button fullWidth color='info' variant="outlined"  onClick={handleClickST}>
        سفارش عدسی آماده جدید
      </Button>
      </Grid>
      <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
      <Button fullWidth color='info' variant="outlined"  onClick={handleClickRX}>
        سفارش عدسی سفارشی جدید
      </Button>
      </Grid>
      <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
      <Button fullWidth color='info' variant="outlined" href="#outlined-buttons" onClick={handleClickOrders}>
        پیگیری سفارش ها
      </Button>
      </Grid>
        </Grid>
        </span>  :

<span>
<HighlightOffIcon sx={{ color: "#E53935" }}/>
<br/>
      <Typography component="div" sx={{ color: "#E53935" }}>
        <ErrorIcon sx={{ color: "#E53935" }} />خطا در نهایی سازی پرداخت &nbsp; {msg} &nbsp;کد &nbsp; {resultCode}
        </Typography></span>   }
      </CardContent>
     

    </Card>
        
</Grid>
</Grid>
    </Box>
    </ThemeProvider>
    </>
  );
}

export default PaymentResult;